// The arenas a form offers: the active ones, plus those it already holds, so an older match or season keeps its
// arena even after that arena was made inactive
export function selectableArenas(arenas, keepIds = []) {
    return arenas.filter(arena => arena.active || keepIds.includes(arena.id))
}

export function arenaLabel(arena) {
    return arena.active === false ? `${arena.name} (inactive)` : arena.name
}
